export const SHORT_TASK_QUESTIONS_1 = [
    {
        id: 1,
        type: '選擇題',
        text: '1.<br/>「生茄子嘗起來就像一顆平淡無味的蘋果，但一經烹調，便搖身變為可口無比的珍饈。酥炸過的茄子會散發美妙的奶油香味，灑些甜中帶辣的香料，風味絕佳。無論是燉煮或烘烤，茄子那種菇蕈般的麝香氣味，都能與鹹味食材完美搭配。除了偷偷咬一小口的方式外，檢查茄子是否具有所需風味與質地最好的方法，就是測試它的緊實度。一顆理想的茄子，外觀應該要像海豚皮膚般緊實光亮，用手揉捏時，還會發出嘎吱嘎吱的聲響。」',
        question: '根據本文，下列關於茄子的風味介紹，何者在文中沒有被提及？',
        options: [
            { text: 'A. 食用口感', },
            { text: 'B. 調味搭配', },
            { text: 'C. 適用醬汁', },
            { text: 'D. 測試方式', },
        ],
        background: '#F8FAFB'
    }, {
        id: 2,
        type: '選擇題',
        text: '2.<br/>「每個人都會在人世中遭遇一些坎坷，我們的身心都可能傷痕累累，但，那也是我們學習的功課。」',
        question: '作者這段文字的意義最接近下列何者?',
        options: [
            { text: 'A. 因為人世中總會遇到一些坎坷，所以身心受創是無法避免的。', },
            { text: 'B. 唯有精進學業，才能以堅毅的心迎戰人世中不可預期的坎坷。', },
            { text: 'C. 雖然人生的坎坷境遇會打擊我們，卻也是我們要面對的挑戰。', },
            { text: 'D. 即便作好萬全準備，遭遇坎坷時仍會給身心帶來巨大的傷害。', },
        ],
        background: '#F8FAFB'

    }, {
        id: 3,
        type: '選擇題',
        text: '3.<br/>「一個項目成功與否，有 60%以上的因素取決於是否能以數行到一頁之間的長度陳述其核心想法，這也是所有業界人士是否願意青睞，考慮要不要繼續看下去的關鍵。」',
        question: '根據本段文字，推論業界人士最需要的是哪一項能力？',
        options: [
            { text: 'A. 高效搜集和整理大量資料的技巧' },
            { text: 'B. 簡潔與精准表達中心觀點的能力' },
            { text: 'C. 快速撰寫與解讀長篇文章的技能' },
            { text: 'D. 具備創意思維和問題解決的能力' },
        ],
        background: '#F8FAFB'
    }, {
        id: 4,
        type: '選擇題',
        text: '4.<br/>「王先生是一位享譽國際的畫家，正忙著準備今天的演講稿。去年，他再度榮獲世界繪畫大獎，讓他躍上了事業巔峰。其實，他並非從小就展現繪畫天分，他曾在課堂上多次被老師訓斥。想起那段往事後，王先生微微一笑，拿起筆，繼續修改眼前的講稿。」',
        question: '關於這段文字的寫作結構，下列分析何者正確?',
        options: [
            { text: 'A. 全文依照時間發生的先後，一步步交代王先生的奮鬥過程。' },
            { text: 'B. 採用倒敘法，先寫王先生事業成功，再說明他成名的原因。' },
            { text: 'C. 文末補充王先生微微一笑，是為了讓讀者掌握主角的心境，屬補敘法。' },
            { text: 'D. 在敘述當下準備演講的過程中，暫時切入小時候的往事，屬於插敘法。' }
        ],
        background: '#F8FAFB'
    }
]